export enum ModuleLibraryLocalStorageKeys {
  lastCreatedVersion = 'MODULE_LIBRARY_LAST_CREATED_VERSION',
}

export enum ModuleGroupLocalStorageKeys {
  lastCreatedVersion = 'MODULE_GROUP_LAST_CREATED_VERSION',
}
